/**
 * @atlassian/jira-issue-create is still using the constants from the current issue-adjustments
 * package, this dependency should be removed in further cyclic deps fix
 */
// eslint-disable-next-line jira/export/no-external-exports
export { GIC_VIEW_TYPE } from '@atlassian/jira-ui-modifications-constants';

export const ON_INIT_CHANGE_ID = 'onInitChangeId';
